import { FormikHelpers } from 'formik';

import { NewCentralFormType } from '../types';

import {
  NotificationContextType,
  NotificationVariant,
} from 'components/notification/notification-types';
import { formatSearchFiltersv3 } from './search-v3-format-filters';
import { InitialBody, InitialResultDto } from './search-v3-types';
import { searchv3Initial } from './search-v3-api';

export const submitInitialSearchFormV3 = (
  setResult: React.Dispatch<React.SetStateAction<InitialResultDto | undefined>>,
  showNotification: NotificationContextType['showNotification'],
  afterSubmit: (
    initialBody: InitialBody,
    initialResult?: InitialResultDto
  ) => Promise<void>
) => async (
  values: NewCentralFormType,
  { setFieldValue, setFieldError, resetForm }: FormikHelpers<NewCentralFormType>
) => {
  try {
    const initialBody = formatSearchFiltersv3(values);
    console.log('initialBody', initialBody);
    console.log('form = ', values);
    const initialResponseJson = await searchv3Initial(initialBody);
    setResult(initialResponseJson);
    await afterSubmit?.(initialBody, initialResponseJson);
  } catch (e) {
    showNotification('Error', NotificationVariant.ERROR, 3);
    setResult(undefined);
    console.log(e);
  }
  return 0;
};
